import React from 'react';
import { Badge, Box, Heading } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/react';
import s from './Title.scss';

export function Title() {
  const { t } = useTranslation();

  return (
    <>
      <Heading size="extraLarge" className={s.landingTitle} textAlign="center">
        {t('devibe.onboarding.title')}
      </Heading>
      <Box style={{ position: 'relative', right: '5px', top: '5px' }}>
        <Badge uppercase="false" skin="neutral" size="small">
          ALPHA
        </Badge>
      </Box>
    </>
  );
}
